<template>
  <div class="room-sticker-list-component">
    <div class="room-sticker-list">
      <button v-for="(sticker, i) in stickerList" :key="i" class="room-sticker-button" :class="sticker" @click="onClickSticker(sticker)">
        <template v-if="i > 9 && i < 20">{{ i === 19 ? 0 : i - 9 }}</template>
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'RoomStickerList',
  data() {
    return {
      stickerList: [
          'sticker_1', 'sticker_2', 'sticker_3', 'sticker_4',
          'sticker_5', 'sticker_6', 'sticker_7', 'sticker_8',
          'sticker_9', 'sticker_10', 'sticker_11', 'sticker_12',
          'sticker_13', 'sticker_14', 'sticker_15', 'sticker_16',
          'sticker_17', 'sticker_18', 'sticker_19', 'sticker_20',
          'sticker_21', 'sticker_22', 'sticker_23', 'sticker_24',
        ]
    }
  },
  computed: {
    ...mapGetters('user', [
      'me'
    ])
  },
  methods: {
    ...mapActions('sticker', [
      'changeRoomUserSticker'
    ]),
    onClickSticker(sticker) {
      this.changeRoomUserSticker(
          {
            userId : this.me.userId,
            stickerId : sticker
          }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.room-sticker-list-component {}
.room-sticker-list {}
.room-sticker-button {
  width: 50%;
  height: 40px;
  font-size: 21px;
  font-weight: 700;
  color: #666;
  transition: 0.1s ease-out;
  @for $i from 1 to 7 {
    &.sticker_#{$i}{
      background: url('~@/assets/images/sticker/sticker_#{$i}.svg') no-repeat center / 20px auto;
    }
  }
  @for $i from 7 to 11 {
    &.sticker_#{$i}{
      background: url('~@/assets/images/sticker/sticker_#{$i}_icon.svg') no-repeat center / 20px auto;
    }
  }
  @for $i from 21 to 25 {
    &.sticker_#{$i}{
      background: url('~@/assets/images/sticker/sticker_#{$i}_icon.svg') no-repeat center / 20px auto;
    }
  }
  &:hover {
    background-color: #fff;
  }
}
</style>